<footer id="footer">
  <div class="clearfix d-block w-100">
    <img class="poweredbycb" [src]="imagePath" alt="Powered by Colossus">
  </div>
  @if (hasPatents) {
    <div class="clearfix view">
      <p>Covered by one or more of the following US Patent Nos.: 10,102,716; 9,704,338; 9,424,716; 9,275,516; 9,196,126; 9,117,341; 8,721,439; 8,721,438; 8,734,241; 8,708,811 and 8,602,884.</p>
    </div>
  }
</footer>

